import { FaArrowRight } from "react-icons/fa6"
import { PropTypes } from 'prop-types';

const Card = ({ img, title,  buttonLabel, buttonLinkURL }) => {

    return (
        <div className="w-full   px-4 py-8 bg-white rounded shadow-sm flex-col justify-start items-center gap-4 flex  transition-all ">
            <img src={img} alt={title} className="w-52 h-auto object-contain rounded" />
            <h1 className="text-center text-[#071946B2] text-2xl px-5 font-bold  uppercase">{title}</h1>
            <div>
                <a
                    href={buttonLinkURL}
                    target="_blank"
                    rel="noreferrer"
                    className="px-8 py-4 bg-red-800 rounded justify-center items-center gap-4 flex"

                >
                    <span className="text-white text-base font-bold capitalize flex items-center gap-3">{buttonLabel} <FaArrowRight /></span>
                </a>
            </div>
        </div>
    )
}
Card.propTypes = {
    img: PropTypes.string,
    title: PropTypes.string,
    buttonLabel: PropTypes.string,
    buttonLinkURL: PropTypes.string
}
export default Card